<div class="d-flex" style="flex-flow: column; height: 100%; width: 100%">
	<div *ngIf="tasks && tasks.length" class="d-flex mb-2" style="align-items: center; justify-content: space-between">
		<span>{{'New task' | translate}}</span>
		<div class="action-btn">
			<a class="btn btn-sm btn-circle btn-outline-primary" routerLink="./create">
				<i data-cy="createTaskButton" class="icon-create" ></i>
			</a>
		</div>
	</div>
	<!-- Tasks lists -->
	<div class="d-flex mb-2" style="flex-grow: 1; flex-flow: column; overflow: auto;">
		<div class="card-list">
			<ng-container *ngIf="!tasks || !tasks.length">
				<div class="d-flex p-2" style="flex-flow: column; justify-content: center; align-items: center;">
					{{'No tasks are present yet' | translate}}
					<a *ngIf="canCreate" routerLink="./create">{{'Click here to create' | translate}}</a>
				</div>
			</ng-container>
			<ng-container *ngFor="let task of tasks; trackById">
				<div class="user-card inner-shadow"> 
					<div class="details">
							<div class="title text-left">{{task.name}}</div>
							<div class="description">{{task.description}}</div>
							<div class=" date">{{task.created_at | date:'short'}}</div>
					<div class="action-btn mt-2" style="text-decoration: none;">
						<a class="btn btn-sm btn-circle btn-outline-primary" (click)="onClickTask(task)" >
							<i class="icon-pencil"></i>
						</a>
						<button class="btn btn-sm btn-circle btn-outline-danger" (click)="onDelete(task.id)">
							<i class="icon-delete"></i>
						</button>
					</div>
				</div>
					<div class="avatar" style="background-image: url('{{task.assigner}}');">
					</div>

				</div>
			</ng-container>
		</div>
	</div>
</div>